const sideViewList = [
    'showNotes',
    'showStaffChat',
    'showAssignSupporter',
    'showSessionInfo',
    'showTicket',
    'showMarkAsDone'
];
const toggleSideBox = (state, stateName) => {
    let _showNotes = !state[stateName];
    for (let i of sideViewList) {
        state[i] = false
    }
    state[stateName] = _showNotes;
    state.showSideBox = _showNotes;
};
const state = () => ({
    showSideBox: false,
    showNotes: false,
    showStaffChat: false,
    showAssignSupporter: false,
    showSessionInfo: false,
    showTicket: false,
    showMarkAsDone: false,
});
const mutations = {
    toggleNotes(state) {
        toggleSideBox(state, 'showNotes')
    },
    toggleStaffChat(state) {
        toggleSideBox(state, 'showStaffChat')
    },
    toggleAssignSupporter(state) {
        toggleSideBox(state, 'showAssignSupporter')
    },
    toggleSessionInfo(state) {
        toggleSideBox(state, 'showSessionInfo')
    },
    toggleTicket(state) {
        toggleSideBox(state, 'showTicket')
    },
    toggleMarkAsDone(state) {
        toggleSideBox(state, 'showMarkAsDone')
    },
    hideAllSideBox(state) {
        for (let i of sideViewList) {
            state[i] = false
        }
        state.showSideBox = false;
    }
};
const actions = {};
const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}